module.exports = __webpack_public_path__ + "static/media/screenshot(19).0d221c47.jpg";